import React, { useEffect, useRef, useState } from 'react';
import { Ripple } from "primereact/ripple";
import { useLocation, Link } from 'react-router-dom';
import {
  IconChevronDown,
  IconHealthRecognition,
  IconCalendarEvent,
  IconClipboardText,
  IconUser,
  IconUsers,
  IconKey,
  IconLayout2,
  IconBuilding,
  IconPointFilled,
  IconPoint,
  IconFileDatabase,
  IconChartBar
} from '@tabler/icons-react';
import { HBL_PA_RESOURCES, REPORT_TYPES } from '../constants/data.cnst';

interface SidebarProps {
  isCollapsed: boolean;
}

type MenuItem = {
  label: string;
  icon?: React.ElementType;
  badge?: string;
  items?: MenuItem[];
  path?: string;
  resource: string;
  active?: boolean;
  disabled?: boolean
};

const menuData: MenuItem[] = [
  { label: "Events", icon: IconCalendarEvent, path: "/dashboard", resource: HBL_PA_RESOURCES.EVENTS, active: true,
    items: [
      { label: "Loco", icon: IconPointFilled, path: "/dashboard", resource: HBL_PA_RESOURCES.LOCO_EVENTS, active: false },
      { label: "Station", icon: IconPointFilled, path: "/dashboard/station-events", resource: HBL_PA_RESOURCES.STATION_EVENTS, active: true, disabled: false }
    ]
  },
  {
    label: "Health", icon: IconHealthRecognition, path: "/health", resource: HBL_PA_RESOURCES.HEALTH,
    items: [
      { label: "Loco", icon: IconPointFilled, path: "/health/loco-health", resource: HBL_PA_RESOURCES.LOCO_HEALTH },
      { label: "Station", icon: IconPointFilled, path: "/health/station-health", resource: HBL_PA_RESOURCES.STATION_HEALTH },
      { label: "Radio", icon: IconPointFilled, path: "/health/radio-health", resource: HBL_PA_RESOURCES.RADIO_HEALTH }
    ]
  },
  { label: "Trip Summary", icon: IconClipboardText, path: "/find-trips", resource: HBL_PA_RESOURCES.TRIP_SUMMARY },
  {
    label: "Operational Monitoring",
    icon: IconClipboardText,
    path: "/report",
    resource: HBL_PA_RESOURCES.REPORT,
    items: [
      {
        label: "Loco Health",
        icon: IconPointFilled,
        path: "/report/loco-health",
        resource: HBL_PA_RESOURCES.LOCO_REPORT,
        items: [
          { label: REPORT_TYPES.HEADER.LOCO_HEALTH.READER_EFFICENCY, icon: IconPoint, path: "/report/loco-health/reader-efficiency", resource: HBL_PA_RESOURCES.LOCO_READER_EFFICIENCY },
          { label: REPORT_TYPES.HEADER.LOCO_HEALTH.RF_ISSUES_LOCO, icon: IconPoint, path: "/report/loco-health/rf-issues-loco", resource: HBL_PA_RESOURCES.LOCO_RF_ISSUES },
          { label: REPORT_TYPES.HEADER.LOCO_HEALTH.CRASH_LOGS, icon: IconPoint, path: "/report/loco-health/crash-logs", resource: HBL_PA_RESOURCES.LOCO_CRASH_LOGS },
          { label: REPORT_TYPES.HEADER.LOCO_HEALTH.CARD_STATUS, icon: IconPoint, path: "/report/loco-health/card-status", resource: HBL_PA_RESOURCES.LOCO_CARD_STATUS },
          { label: REPORT_TYPES.HEADER.LOCO_HEALTH.BRAKE_VC_LOGS_MONITORING, icon: IconPoint, path: "/report/loco-health/brake-failure", resource: HBL_PA_RESOURCES.LOCO_BRAKE_VC_LOGS_MONITORING },
          { label: REPORT_TYPES.HEADER.LOCO_HEALTH.CARD_DIAGNOSTICS, icon: IconPoint, path: "/report/loco-health/card-diagnostics", resource: HBL_PA_RESOURCES.LOCO_CARD_DIAGNOSTICS },
          { label: REPORT_TYPES.HEADER.LOCO_HEALTH.DMI_HEALTH_MONITORING, icon: IconPoint, path: "/report/loco-health/dmi-health-monitoring", resource: HBL_PA_RESOURCES.LOCO_DMI_HEALTH_MONITORING },
          { label: REPORT_TYPES.HEADER.LOCO_HEALTH.SPEEDOMETER_HEALTH_MONITORING, icon: IconPoint, path: "/report/loco-health/speedometer-health-monitoring", resource: HBL_PA_RESOURCES.LOCO_SPEEDOMETER_HEALTH_MONITORING },
          { label: REPORT_TYPES.HEADER.LOCO_HEALTH.RADIO_PARAMETERS_MONITORING, icon: IconPoint, path: "/report/loco-health/radio-parameters-monitoring", resource: HBL_PA_RESOURCES.LOCO_RADIO_PARAMETERS_MONITORING },
          { label: REPORT_TYPES.HEADER.LOCO_HEALTH.CHECKSUM_CHANGE_REPORT, icon: IconPoint, path: "/report/loco-health/checksum-change-report", resource: HBL_PA_RESOURCES.LOCO_CHECKSUM_CHANGE },
          { label: REPORT_TYPES.HEADER.LOCO_HEALTH.CAB_RFID_READER, icon: IconPoint, path: "/report/loco-health/cab-rfid-reader", resource: HBL_PA_RESOURCES.LOCO_CAB_RFID_READER },
        ]
      },
      {
        label: "Station Health",
        icon: IconPointFilled,
        path: "/report/station-health",
        resource: HBL_PA_RESOURCES.STATION_REPORT,
        items: [
          { label: REPORT_TYPES.HEADER.STATION_HEALTH.EIGW_FAILURE, icon: IconPoint, path: "/report/station-health/eigw-failure", resource: HBL_PA_RESOURCES.STATION_EIGW_FAILURE },
          { label: REPORT_TYPES.HEADER.STATION_HEALTH.S2S_LINK_FAILURE, icon: IconPoint, path: "/report/station-health/s2s-link-failure", resource: HBL_PA_RESOURCES.STATION_S2S_LINK_FAILURE },
          { label: REPORT_TYPES.HEADER.STATION_HEALTH.RF_ISSUES_STATION, icon: IconPoint, path: "/report/station-health/rf-issues-station", resource: HBL_PA_RESOURCES.STATION_RF_ISSUES },
          { label: REPORT_TYPES.HEADER.STATION_HEALTH.CARD_STATUS, icon: IconPoint, path: "/report/station-health/card-status", resource: HBL_PA_RESOURCES.STATION_CARD_STATUS },
          { label: REPORT_TYPES.HEADER.STATION_HEALTH.CRASH_LOGS, icon: IconPoint, path: "/report/station-health/crash-logs", resource: HBL_PA_RESOURCES.STATION_CRASH_LOGS },
          { label: REPORT_TYPES.HEADER.STATION_HEALTH.CARD_DIAGNOSTICS, icon: IconPoint, path: "/report/station-health/card-diagnostics", resource: HBL_PA_RESOURCES.STATION_CARD_DIAGNOSTICS },
          { label: REPORT_TYPES.HEADER.STATION_HEALTH.RADIO_PARAMETERS_MONITORING, icon: IconPoint, path: "/report/station-health/radio-parameters-monitoring", resource: HBL_PA_RESOURCES.STATION_RADIO_PARAMETERS_MONITORING },
          { label: REPORT_TYPES.HEADER.STATION_HEALTH.CHECKSUM_CHANGE_REPORT, icon: IconPoint, path: "/report/station-health/checksum-change-report", resource: HBL_PA_RESOURCES.STATION_CHECKSUM_CHANGE },
          { label: REPORT_TYPES.HEADER.STATION_HEALTH.FIU, icon: IconPoint, path: "/report/station-health/fiu", resource: HBL_PA_RESOURCES.STATION_FIU },
          { label: REPORT_TYPES.HEADER.STATION_HEALTH.SYSTEM_FAILURE, icon: IconPoint, path: "/report/station-health/system-failure", resource: HBL_PA_RESOURCES.STATION_SYSTEM_FAILURE },
          { label: REPORT_TYPES.HEADER.STATION_HEALTH.CHANGEOVER_OF_CARDS, icon: IconPoint, path: "/report/station-health/changeover-of-cards", resource: HBL_PA_RESOURCES.STATION_CHANGEOVER_OF_CARDS },
          { label: REPORT_TYPES.HEADER.STATION_HEALTH.RIU, icon: IconPoint, path: "/report/station-health/riu", resource: HBL_PA_RESOURCES.STATION_RIU },
          { label: REPORT_TYPES.HEADER.STATION_HEALTH.SIGNAL_ASPECT_BLANKING, icon: IconPoint, path: "/report/station-health/signal-aspect-blanking", resource: HBL_PA_RESOURCES.STATION_SIGNAL_ASPECT_BLANKING },
          { label: REPORT_TYPES.HEADER.STATION_HEALTH.MONITORING_BOOT_LOGS, icon: IconPoint, path: "/report/station-health/monitoring-boot-logs", resource: HBL_PA_RESOURCES.STATION_MONITORING_BOOT_LOGS },
        ]
      },
      {
        label: "Events",
        icon: IconPointFilled,
        path: "/report/events",
        resource: HBL_PA_RESOURCES.EVENTS_REPORT,
        items: [
          { label: REPORT_TYPES.HEADER.EVENTS.TAG_MISSING, icon: IconPoint, path: "/report/events/tag-missing", resource: HBL_PA_RESOURCES.EVENTS_TAG_MISSING },
          { label: REPORT_TYPES.HEADER.EVENTS.TAG_MISSING_NEW, icon: IconPoint, path: "/report/events/tag-new", resource: HBL_PA_RESOURCES.EVENTS_TAG_MISSING_NEW },
          { label: REPORT_TYPES.HEADER.EVENTS.UNWANTED_BRAKING, icon: IconPoint, path: "/report/events/unwanted-braking", resource: HBL_PA_RESOURCES.EVENTS_UNWANTED_BRAKING },
          { label: REPORT_TYPES.HEADER.EVENTS.SIGNAL_BLANKING, icon: IconPoint, path: "/report/events/signal-blanking", resource: HBL_PA_RESOURCES.EVENTS_SIGNAL_BLANKING },
        ]
      }
    ]
  },
  {
    label: "Station Metadata",
    icon: IconFileDatabase,
    path: "/station-metadata",
    resource: HBL_PA_RESOURCES.STATION_METADATA,
  },
  { label: "Unified KPI", icon: IconChartBar, path: "/unified-kpi", resource: HBL_PA_RESOURCES.UNIFIED_KPI },
  {
    label: "User Management",
    icon: IconUser,
    path: "/usermgmt",
    resource: HBL_PA_RESOURCES.USERMGMT,
    items: [
      { label: 'Organizations', icon: IconBuilding, path: '/usermgmt/customer', resource: HBL_PA_RESOURCES.USERMGMT },
      { label: 'Applications', icon: IconLayout2, path: '/usermgmt/applications', resource: HBL_PA_RESOURCES.USERMGMT },
      { label: 'Roles', icon: IconKey, path: '/usermgmt/roles', resource: HBL_PA_RESOURCES.USERMGMT },
      { label: 'Users', icon: IconUsers, path: '/usermgmt/users', resource: HBL_PA_RESOURCES.USERMGMT },
    ]
  }
];

const SubMenu = ({ item, isCollapsed, level = 0 }: { item: MenuItem; isCollapsed: boolean; level?: number }) => {
  const location = useLocation();


  let permissions = JSON.parse(localStorage.getItem("userPermissions") || "null");
  const isAdmin = !!permissions?.[HBL_PA_RESOURCES.USERMGMT];
  const roleName = permissions?.[HBL_PA_RESOURCES.USERMGMT]?.roleName;
  if (item.path === "/usermgmt/customer" && roleName === "Customer Administrator") {
    return null;
  }

  const itemRef = useRef<HTMLLIElement>(null);
  const hasSubmenu = item.items && item.items.length > 0;
  const isActive = item.path ? location.pathname.includes('station-events') ? item.active : location.pathname.includes(item.path) : false;
  const [isOpen, setIsOpen] = useState(isActive && hasSubmenu);
  useEffect(() => {
    if (!isActive) return;

    // Wait until submenu animation/layout finishes
    requestAnimationFrame(() => {
      setTimeout(() => {
        itemRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest"
        });
      }, 150);
    });
  }, [isActive, isOpen]);

  useEffect(() => {
    if (!hasSubmenu) return;

    const isRouteInsideSubmenu =
      item.items?.some(
        (sub) => sub.path && location.pathname.includes(sub.path)
      ) || false;

    setIsOpen(isRouteInsideSubmenu);
  }, [location.pathname]);

  const toggleSubmenu = () => {
    if (hasSubmenu && !isCollapsed) {
      setIsOpen(!isOpen);
    }
  };

  const Icon = item.icon;

  const content = (
    <>
      <div className={`flex items-center ${isCollapsed ? 'justify-center w-full' : ''}`}>
        {Icon && (
          <Icon
            className={`${isCollapsed ? '' : 'mr-3'} ${isActive ? 'text-brand-600 dark:text-brand-50' : 'text-gray-500 dark:text-gray-300'} transition-colors duration-200`}
            size={20}
            stroke={1.5}
          />
        )}
        {!isCollapsed && (
          <span className={`truncate whitespace-normal ${isActive ? 'text-brand-600 dark:text-brand-50' : 'text-gray-600 dark:text-gray-300'} transition-colors duration-200`}>
            {item.label}
          </span>
        )}
      </div>

      {!isCollapsed && (
        <>
          {item.badge && (
            <span className="inline-flex items-center justify-center ml-auto bg-blue-500 text-white rounded-full w-5 h-5 text-[10px] font-bold">
              {item.badge}
            </span>
          )}
          {hasSubmenu && (
            <IconChevronDown
              className={`ml-auto text-gray-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
              size={16}
            />
          )}
        </>
      )}
      <Ripple />
    </>
  );

  const className = `p-ripple flex items-center cursor-pointer p-3 rounded-lg transition-all duration-200 w-full mb-1 min-h-[44px]
    ${isActive ? 'bg-brand-50 dark:bg-brand-600' : 'hover:bg-gray-50 dark:hover:bg-gray-800'} 
    ${isCollapsed ? 'justify-center px-2' : 'justify-between'}`;

  // Use inline style for padding to ensure robust indentation
  const style = !isCollapsed && level > 0 ? { paddingLeft: `${12 + level * 16}px` } : {};

  return (
    <li ref={isActive ? itemRef : null} style={{
      ...(permissions?.[HBL_PA_RESOURCES.HBL_PA]?.resources?.[item.resource] ||
        (isAdmin && permissions?.[item.resource])
        ? {}
        : { display: 'none' }),
      ...(item.disabled ? { pointerEvents: 'none',  opacity: 0.5 } : {}),
    }}>
      {item.path && !hasSubmenu ? (
        <Link to={item.path} className={className} title={isCollapsed ? item.label : ''} style={style}>
          {content}
        </Link>
      ) : (
        <a className={className} onClick={toggleSubmenu} title={isCollapsed ? item.label : ''} style={style}>
          {content}
        </a>
      )}

      {hasSubmenu && (
        <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen && !isCollapsed ? 'max-h-[2800px] opacity-100' : 'max-h-0 opacity-0'}`}>
          <ul className={`list-none py-0 m-0 flex flex-col gap-1 ${level === 0 ? 'ml-4 border-l border-gray-200 dark:border-gray-700 pl-2' : ''}`}>
            {item.items!.map((subItem, index) => (
              <SubMenu key={index} item={subItem} isCollapsed={isCollapsed} level={level + 1} />
            ))}
          </ul>
        </div>
      )}
    </li>
  );
};

export default function Sidebar({ isCollapsed }: SidebarProps) {
  const [isHoverExpanded, setIsHoverExpanded] = useState(false);

  const isSidebarExpanded = !isCollapsed || isHoverExpanded;
  return (
    <div
      className={`flex relative lg:static bg-white dark:bg-gray-900 border-r border-gray-100 dark:border-gray-800 transition-all duration-100 ease-in-out ${!isSidebarExpanded ? 'min-w-20' : 'min-w-72'}`}
      onMouseEnter={() => {
        setTimeout(() => {
          if (isCollapsed) setIsHoverExpanded(true);
        })
      }}
      onMouseLeave={() => {
        setTimeout(() => {
          setIsHoverExpanded(false);
        })
      }}>
      <div className="bg-white dark:bg-gray-900 h-[calc(100vh-4rem)] block shrink-0 absolute lg:static left-0 top-0 z-10 select-none w-full overflow-hidden">
        <div className="flex flex-col h-full">
          <div className="overflow-y-auto py-4 px-3 scrollbar-hide">
            <ul className="list-none p-0 m-0 flex flex-col gap-1">
              {menuData.map((item, index) => (
                <SubMenu key={index} item={item} isCollapsed={!isSidebarExpanded} />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
